import { render, staticRenderFns } from "./EditReferModal.vue?vue&type=template&id=48368551"
import script from "./EditReferModal.vue?vue&type=script&lang=js"
export * from "./EditReferModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports